import React, { useEffect, useState, useContext } from 'react'
import { CButton, CCol, CFormLabel, CRow } from '@coreui/react'
import './imageUploader.scss'
import { getThumbnail, isEmpty, raiseToast } from '../../views/utils/helper'
import ImageCropper from '../../views/container/cms/imageCroper'
import { useFileChange } from 'src/s3upload/use-file-change'
import { uploadToS3 } from 'src/s3upload/upload-file'
import { getImageCropObj } from '../../views/utils/helper'
import { AppContext } from 'src/views/context/app'
import { GlobalContext } from 'src/views/context/GlobalState'
import Compressor from 'compressorjs'
import UploadIcon from '../../assets/upload-icon.svg'
import RemoveIcon from '../../assets/img-upload-remove.svg'
// import AssetManager from 'src/views/container/AssetManager/AssetManager'
import AssetManagerNew from 'src/views/container/AssetManager/AssetManagerNew'

const ImageUploader = ({ data, isDisabled = false }) => {
  const accountId = localStorage.getItem('accountId')
  const { fileName, fileContents, fileType, fileSize, fileDispatch, handleFileChange } =
    useFileChange()
  const { setLoader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [renderData, setRenderData] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [selectedImage, setSelectedImage] = useState({})
  const [showAssetManager, setShowAssetManager] = useState(false)

  const [imageCropModal, setImageCropModal] = useState(false)
  const [imageURLs, setImageURLs] = useState([''])
  const [imageCropObj, setImageCropObj] = useState({
    src: '',
    imageName: '',
    crop: {
      unit: 'px',
      width: 200,
      height: 200,
    },
    imageType: '',
    error: null,
  })

  useEffect(() => {
    handleRenderProps()
  }, [data])

  const handleRenderProps = () => {
    let tempImageURLs = []
    data.forEach((element) => {
      if (!element.assetId) {
        tempImageURLs.push('')
      } else {
        tempImageURLs.push(element['imageUrl'])
      }
    })
    setImageURLs(tempImageURLs)
    setRenderData(data)
  }

  const handleImage = async (event, index, info, width, height) => {
    const image = event.target.files[0]
    const imageURL = URL.createObjectURL(image)
    setSelectedIndex(index)
    setSelectedImage(info)
    const img = new Image()
    img.onload = function () {
      setImageCropObj(() => ({
        crop: getImageCropObj(this.width, this.height, width, height),
        src: imageURL,
        imageName: image.name,
        imageType: image.type,
      }))
    }
    img.src = imageURL

    setImageCropModal(true)
  }

  const handleCompressedUpload = (imageUrl, blob, imageRef) => {
    setLoader(true)

    new Compressor(blob, {
      quality: 0.8,
      success: (compressedResult) => {
        // compressedResult has the compressed file.
        fileDispatch({
          type: 'FILE_CHANGE_SUCCESS',
          fileName: compressedResult.name,
          fileSize: compressedResult.size,
          fileType: compressedResult.type,
          fileContents: compressedResult,
        })
        let tempImage = imageURLs
        tempImage[selectedIndex] = window.URL.createObjectURL(compressedResult)
        setImageURLs(tempImage)
        setImageCropObj({})
      },
      error: (err) => {
        console.log(err.message)
        raiseToast('error', 'Try Again!')
        setLoader(false)
        setImageCropObj({})
      },
    })
  }

  const onImageLoad = async (e, url) => {
    if (url.includes(userSessionObj.session_data.cf_domain_name)) {
      return
    }
    try {
      if (fileType && fileContents) {
        let tempName = fileName.replace(/ /g, '_')
        let data = {
          customer_id: accountId,
          upload_type: 'FROM_DEVICE',
          assets: [
            {
              file_name: tempName,
              file_metadata: {
                file_size: fileSize,
                file_type: fileType,
              },
            },
          ],
        }
        const status = await uploadToS3({ fileContents, data, fileType: 'image' })
        if (status?.success) {
          console.log('status', status)
          selectedImage.setAssetId(status.assetId)
          selectedImage.setImage(status)
          setLoader(false)
        } else {
          setLoader(false)
        }
        fileDispatch({ type: 'RESET_FILE_STATE' })
      }
    } catch (err) {
      console.log('error is', err)
    }
  }

  const handleAssetSelect = async (info) => {
    try {
      let url = getThumbnail(userSessionObj.session_data.cf_domain_name, info.s3_key)

      let blob = await fetch(url).then((r) => r.blob())
      console.log('blob', blob)
      let imageURL = URL.createObjectURL(blob)

      const img = new Image()
      img.onload = function () {
        setImageCropObj(() => ({
          crop: getImageCropObj(this.width, this.height, selectedImage.width, selectedImage.height),
          src: imageURL,
          imageName: info.file_name,
          imageType: info?.file_metadata?.file_type,
        }))
      }
      img.src = imageURL

      setImageCropModal(true)
    } catch (error) {
      console.error(error)
    }
  }

  const handleRemoveImg = (index) => {
    let tempImageURLs = imageURLs
    tempImageURLs[index] = ''
    setImageURLs(tempImageURLs)
    fileDispatch({ type: 'RESET_FILE_STATE' })
    renderData[index].setAssetId('')
    renderData[index]?.onRemoveImg()
  }

  return (
    <div className="d-flex justify-content-between" style={{ opacity: isDisabled ? '0.5' : '1' }}>
      {!isEmpty(renderData) &&
        renderData.map((info, index) => {
          const btnWidth =
            Number(info.divwidth.replace(/\D+$/g, '')) > Number(7.45) ? '7.5rem' : '95%'

          const setImgPaddingX = info?.imagePaddingX || '5px'
          const setImgPaddingY = info?.imagePaddingY || '5px'
          const imgUploaderBg = info?.imgUploaderBg || '#fff'
          const imgUploaderDivFlex =
            info?.imgUploaderDivFlex || 'flex-column justify-content-center align-items-center'

          return (
            <CRow className="" key={index}>
              <CCol style={{ textAlign: 'center' }}>
                {!info?.titleDisabled && (
                  <CFormLabel className="image-type-active">{`${info.title}`}</CFormLabel>
                )}

                <div
                  style={{
                    height: `${info.divheight}`,
                    width: `${info.divwidth}`,
                    border: `solid 1.5px ${imageURLs[index] ? '#2172eb' : '#707070'}`,
                  }}
                  className={'uploader-image-div'}
                >
                  {!imageURLs[index] ? (
                    <div
                      style={{ background: isDisabled ? '#e2e2e2' : imgUploaderBg }}
                      className={`d-flex h-100 ${imgUploaderDivFlex} `}
                    >
                      {!info?.hideUploadIcon && (
                        <div
                          style={{ marginTop: '5px' }}
                          className={`d-flex ${
                            info?.uploadIconflexRow ? '' : 'flex-col'
                          } justify-content-center align-items-center w-75`}
                        >
                          <>
                            <img
                              src={UploadIcon}
                              style={{
                                width: `${info?.uploadIconsize ? info?.uploadIconsize : '1rem'}`,
                                height: `${info?.uploadIconsize ? info?.uploadIconsize : '1rem'}`,
                              }}
                              className="mx-1"
                              alt="upload-icon"
                            />
                            <span style={{ color: '#707070', fontSize: '10px' }}>
                              {info?.customUploadText ? info?.customUploadText : 'Upload Image'}{' '}
                            </span>
                          </>
                        </div>
                      )}
                      <div
                        className={`w-100 d-flex align-items-center justify-content-center ${
                          btnWidth === '7.5rem' && 'px-2'
                        } `}
                        style={{ flexDirection: info?.btnDivFlexRow ? 'row' : 'column' }}
                      >
                        <CButton
                          className={`text-white ${info.btnXmargin ? info.btnXmargin : ''}`}
                          style={{
                            marginTop: `${info?.btnMarginTop ? info?.btnMarginTop : '10px'}`,
                            padding: info?.btnPadding ? info?.btnPadding : '.375rem .75rem',
                            background: '#20211c',
                            fontSize: '9px',
                            width: `${btnWidth}`,
                          }}
                          onClick={() => {
                            setShowAssetManager(true)
                            setSelectedIndex(index)
                            setSelectedImage(info)
                          }}
                          disabled={isDisabled}
                        >
                          {info?.customOptionOneText
                            ? info?.customOptionOneText
                            : 'From Asset Manager'}
                        </CButton>
                        <label
                          style={{ width: `${btnWidth}` }}
                          htmlFor={!isDisabled ? `${info.id}${index}` : ''}
                          className={`${info.btnXmargin ? info.btnXmargin : ''}`}
                        >
                          <CButton
                            className={`text-white`}
                            style={{
                              marginTop: `${info?.btnMarginTop ? info?.btnMarginTop : '10px'}`,
                              padding: info?.btnPadding ? info?.btnPadding : '.375rem .75rem',
                              background: '#20211c',
                              fontSize: '9px',
                              width: `100%`,
                            }}
                            component="span"
                            disabled={isDisabled}
                          >
                            From Device
                          </CButton>
                        </label>
                      </div>
                      {/* <CFormText
                        className={'mt-2'}
                        style={{ fontSize: '10.5px', color: '#4a4a49' }}
                      >
                        For best resolution image file should be {`${info.width} X ${info.height}`}{' '}
                        px. Format should be .jpeg or .png.
                      </CFormText> */}
                    </div>
                  ) : (
                    <div
                      style={{ padding: `${setImgPaddingY} ${setImgPaddingX}`, background: '#fff' }}
                      className="place-holder-div"
                    >
                      <img
                        className="place-holder-img"
                        src={imageURLs[index] || ''}
                        alt={'thumbnail website'}
                        onLoad={(e) => onImageLoad(e, imageURLs[index])}
                      />
                      <img
                        src={RemoveIcon}
                        alt="remove"
                        className=" position-absolute cursor-pointer"
                        style={{ widht: '14.5px', height: '14.5px', top: '2px', right: '2px' }}
                        onClick={() => {
                          setSelectedImage(info)
                          handleRemoveImg(index)
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    name={`${info.id}${index}`}
                    id={`${info.id}${index}`}
                    onChange={(e) => {
                      handleImage(e, index, info, info.width, info.height)
                      handleFileChange(e)
                    }}
                  />
                </div>
              </CCol>
            </CRow>
          )
        })}

      {imageCropObj.src && imageCropModal && (
        <ImageCropper
          openModal={imageCropModal}
          locked={true}
          imageCropObj={imageCropObj}
          closeModalHandle={() => {
            setImageCropModal(false)
            setImageCropObj({})
          }}
          handleCallback={handleCompressedUpload}
        />
      )}

      {showAssetManager && (
        <AssetManagerNew
          onCancel={() => setShowAssetManager(false)}
          type={'image'}
          setAsset={(info) => {
            handleAssetSelect(info)
            setShowAssetManager(false)
          }}
        />
      )}
    </div>
  )
}

export default ImageUploader
